import { CountrySelect } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useCustomerForm } from '../../../../contexts/customerFormContext'
import { ShippingAddressInputFieldProps } from '../../types/shippingAddressInputFieldProps'

type ShippingAddressCountryProps = ShippingAddressInputFieldProps

export const ShippingAddressCountry = ({ isDisabled }: ShippingAddressCountryProps): ReactElement => {
  const { t } = useTranslation()
  const { customerForm } = useCustomerForm()
  const { FormItem } = customerForm

  return (
    <FormItem
      label={t('customer_modal.form.shipping_address.country.label')}
      name="shippingAddress.country"
      render={({ field: { value, onChange, ...rest } }) => (
        <CountrySelect
          {...rest}
          disabled={isDisabled}
          dropdownSize="fitTrigger"
          onSelect={(id) => onChange(id)}
          selectedId={value}
          size="sm"
        />
      )}
    />
  )
}
